import React from 'react'
import {css} from '@emotion/core'

import {FadeIn} from './fade-in'
import Picture from '../components/picture'
import generalMillsLogo from '../../img/logos/general-mills-logo.png'
import legoLogo from '../../img/logos/lego-logo.png'
import millerLiteLogo from '../../img/logos/miller-lite-logo.png'
import netflixLogo from '../../img/logos/netflix-logo.png'
import nikeLogo from '../../img/logos/nike-logo.png'
import universalLogo from '../../img/logos/universal-logo.png'
import generalMillsLogoWebp from '../../img/logos/general-mills-logo.webp'
import legoLogoWebp from '../../img/logos/lego-logo.webp'
import millerLiteLogoWebp from '../../img/logos/miller-lite-logo.webp'
import netflixLogoWebp from '../../img/logos/netflix-logo.webp'
import nikeLogoWebp from '../../img/logos/nike-logo.webp'
import universalLogoWebp from '../../img/logos/universal-logo.webp'

const SocialProofSectionContent = ({fadeIn, children}) => (
  fadeIn ? <FadeIn>{children}</FadeIn> : children
)

interface Props {
  fadeIn?: boolean
  a8: string
}

const SocialProofSection : React.FC<Props> = ({fadeIn, a8}) => (
  <section
    className='container-fluid homepage small-content dark'
    style={{background: '#7611B6'}}
  >
    <SocialProofSectionContent fadeIn={fadeIn}>
      <div
        className='row justify-content-center align-items-center text-center'
        style={{padding: '0 1em'}}
      >
        <p style={{fontWeight: 900}}>
          Join the world&apos;s most innovative brands in WebAR excellence
        </p>
        <a
          href='/try-free-trial'
          id='anchor-button'
          a8={a8}
          css={css`
            margin: 0 0 7px 10px;
            @media screen and (max-width: 767px) {
              margin: 10px 0;
            }
          `}
        >
          Start a free trial of 8th Wall
        </a>
      </div>
      <div
        className='row justify-content-center align-items-center text-center'
        style={{marginTop: '1em'}}
      >
        <Picture
          className='img-fluid brand-logo d-none d-lg-block'
          pngSrc={universalLogo}
          webpSrc={universalLogoWebp}
          alt='Sony Logo'
        />
        <Picture
          className='img-fluid brand-logo'
          pngSrc={generalMillsLogo}
          webpSrc={generalMillsLogoWebp}
          alt='General Mills Logo'
        />
        <Picture
          className='img-fluid brand-logo'
          pngSrc={nikeLogo}
          webpSrc={nikeLogoWebp}
          alt='Redbull Logo'
        />
        <Picture
          className='img-fluid brand-logo'
          pngSrc={legoLogo}
          webpSrc={legoLogoWebp}
          alt='Lego Logo'
        />
        <Picture
          className='img-fluid brand-logo d-none d-lg-block'
          pngSrc={netflixLogo}
          webpSrc={netflixLogoWebp}
          alt='AWS Logo'
        />
        <Picture
          className='img-fluid brand-logo d-none d-lg-block'
          pngSrc={millerLiteLogo}
          webpSrc={millerLiteLogoWebp}
          alt='Miller Lite Logo'
        />
      </div>
    </SocialProofSectionContent>
  </section>
)

export default SocialProofSection
